import { LRLanguage, LanguageSupport } from '@codemirror/language';
import { styleTags, tags as t } from '@lezer/highlight';

import { parser } from './junos-parser.js';

const junosLanguage = LRLanguage.define({
  parser: parser.configure({
    props: [
      styleTags({
        version: t.propertyName,
        VersionNumber: t.string,
        'PropertyName/Identifier': t.propertyName,
        'Value/Identifier': t.variableName,
        Number: t.number,
        'IpPrefix/Number': t.number,
        'Ipv6Prefix/Number': t.number,
        String: t.string,
        IpAddress: t.atom,
        Ipv6Address: t.atom,
        '"/"': t.operator,
        LineComment: t.lineComment,
        BlockComment: t.blockComment,
        '{ }': t.brace,
        '[ ]': t.squareBracket,
        ';': t.separator
      })
    ]
  }),
  languageData: {
    commentTokens: { line: '#', block: { open: '/*', close: '*/' } },
    wordChars: '-_./:'
  }
});

export function junos() {
  return new LanguageSupport(junosLanguage);
}

export { junosLanguage };
